module.exports = __webpack_public_path__ + "static/media/bg.8f53dd17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.jpg
// module id = 288
// module chunks = 0